import memoize from "lodash/memoize";

import { highlight } from "@regal-voice/ui";

type HighlightCustomVariablesProps = {
    text: string;
    isPlainText?: boolean;
};

const highlightedText = memoize((text: string) => {
    return highlight(text);
});

function getLinkElement(element: HTMLElement) {
    if (element.tagName?.toLowerCase() === "a") {
        return element;
    }

    if (element.parentElement?.tagName?.toLowerCase() === "a") {
        return element.parentElement;
    }

    return null;
}

const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const targetElement = getLinkElement(event.target as HTMLElement);
    // if we clicked one of our links
    if (targetElement) {
        event.preventDefault();
    }
};

export default function HighlightCustomVariables({ text, isPlainText = false }: HighlightCustomVariablesProps) {
    return (
        // highlighting variables implies that we return HTML because we need to colorize parts of the text
        // which we do by inserting `<span />` elements with custom classes
        // but if the text we're going to send to the highlight function is plain text
        // the new line characters will behave differently when inserted into an HTML fragment (than when used in a plain text context)
        // so we need to create new line tags for each new line character
        // in order to preserve new lines

        <span
            // eslint-disable-next-line react/no-danger -- This use is properly sanitized
            dangerouslySetInnerHTML={{ __html: highlightedText(isPlainText ? text.replace(/\n/g, "<br>") : text) }}
            onClick={handleClick}
        />
    );
}
